module.exports = __webpack_public_path__ + "static/media/抽象画生成真实图片（加载较慢）.5ceaf193.png";